import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { take } from "rxjs/operators";
import { OrderModel } from 'src/app/models/order.model';
import { ProfileDetailsModel, ProfileModel } from 'src/app/models/profile.model';
import { DataService } from 'src/app/services/data/data.service';
import { MathService } from 'src/app/services/math/math.service';


@Component({
  selector: 'notified-list',
  templateUrl: './notified-list.component.html',
  styleUrls: ['./notified-list.component.scss'],
})
export class NotifiedListComponent implements OnInit {

  @Input()
  title:string;

  @Input()
  mode:string // edit, view, order, catalog, sale

  @Input()
  loading:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  order:OrderModel;


  @Input('items')
  set items(items:any[]|any[]){
    if(items){
      items.forEach(item =>{
        this.dataService
        .getConsumerDetails(item.key)
        .pipe(take(1))
        .subscribe(result => {
          if(!result || !result.shortDetails || !result.shortDetails.name){
            item.details = {
              shortDetails:{
                name:this.translateService.instant("notification.LocalUser")
              }
            }
          }
          else{
            item.details = result;
          }
          this._items.push(item);
          this._items = this._items.sort((a,b) => {
            return (a.details.shortDetails.name < b.details.shortDetails.name)?-1:1;
          })
        });
      });
      // this._items = items.map(item => {
      //   this.dataService
      //     .getConsumerShortDetails(item.key)
      //     .pipe(take(1))
      //     .subscribe(result => {
      //       item.details = result;
      //       console.log(item);
      //     });
      // });      
    }

  }

  _items:ProfileDetailsModel[]|any[] = [];

  @Input()
  sortBy:string

  @Input()
  owner:ProfileModel;

  constructor(private dataService:DataService, private navCtrl:NavController, 
    private alertCtrl:AlertController, public mathService:MathService,
    private modalCtrl:ModalController, public translateService:TranslateService) {


  }

  

  sortItems(type: string): void {
      this._items = this._items.sort((a, b) => {
        const ashortname = a.details && a.details.shortDetails ? a.details.shortDetails.name : "";
        const bshortname = b.details && b.details.shortDetails ? b.details.shortDetails.name : "";
        return ashortname < bshortname ? -1 : 0;
      });
  }


  ngOnInit(){

  }

}
